import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { EMPTY, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeService } from 'src/app/shared/services/attribute.service';

@Component({
  selector: 'app-enumerated-aggregate-item',
  templateUrl: './enumerated-aggregate-item.component.html',
  styleUrls: ['./enumerated-aggregate-item.component.scss'],
})
export class EnumeratedAggregateItemComponent implements OnInit, OnDestroy {
  @Input() answers: string[];
  allPosiibleAnswers: EnumeratedAggregateAnswers[] = [];
  @Input() questionId: string;
  @Input() evaluatorsCount: number;
  subscription: Subscription;
  private _aggregateAnswers: EnumeratedAggregateAnswers[] = [];
  constructor(private attributeService: AttributeService) {}

  ngOnInit(): void {
    this.setAggregateAnswers();
    this.subscription = this.attributeService.attributes
      .pipe(map((attr) => this.setAllPosiibleAnswersAnswers(attr, this.questionId)))
      .subscribe((result) => {
        if (result) {
          this.allPosiibleAnswers = result;
        }
      });
  }

  private setAggregateAnswers() {
    this._aggregateAnswers = _.chain(this.answers)
      .groupBy()
      .map((value) => {
        return value;
      })
      .value()
      .map<EnumeratedAggregateAnswers>((aggregate) => {
        return {
          name: aggregate[0],
          value: aggregate.length,
          percentage: Math.round((aggregate.length * 100) / this.evaluatorsCount),
        };
      });
  }

  private setAllPosiibleAnswersAnswers(attributes: AttributeDefinition[], questionId: string) {
    if (!attributes) return null;
    return attributes
      .find((a) => a.id == questionId)
      .valueList.map<EnumeratedAggregateAnswers>((v) => {
        let item = this._aggregateAnswers.find((a) => a.name == v.itemValue);
        if (item) {
          return { name: item.name, value: item.value, percentage: item.percentage };
        } else return { name: v.itemValue, value: 0, percentage: 0 };
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

interface EnumeratedAggregateAnswers {
  name: string;
  value: number;
  percentage: number;
}
